"use client";

import * as React from "react";
import Link from "next/link";
import { ChartCard, PreviewLineChart } from "@/components";
import { UsersIcon } from "@/icons";
import { useAdoptionSinceLaunch } from "@/hooks/use-adoption";

export function Adoption() {
  const { data, isLoading } = useAdoptionSinceLaunch();
  const fields = React.useMemo(() => data?.chart?.fields, [data]);

  const lines = React.useMemo(() => {
    if (!fields) return [];
    return Object.keys(fields).map((el) => ({
      dataKey: el,
      name: fields[el].title,
      stroke: fields[el].color,
    }));
  }, [fields]);

  return (
    <Link href="/explore/adoption" className="block h-full cursor-pointer">
      <ChartCard
        title="Adoption"
        icon={<UsersIcon size={20} color="#FF0F6F" />}
        isLoading={isLoading}
        accent="Network"
        description="Holders and stakers since launch"
      >
        <PreviewLineChart data={data?.data ?? []} lines={lines} />
      </ChartCard>
    </Link>
  );
}
